__turbopack_context__.v({
  "pill": "H8a3OW_pill",
});
